import "./PageContainer.scss";

import type { ReactNode } from "react";

export interface PageContainerProps {
  children: ReactNode;
}

/**
 * Wraps full-width page content with consistent padding. Breadcrumbs live in
 * the layout; pages set them via useBreadcrumbs() and render PageHeader (back link, title) here.
 */
export function PageContainer({ children }: PageContainerProps) {
  return <div className="app-page-container">{children}</div>;
}
